import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, FormControl, MenuItem, Select, Typography } from '@material-ui/core';
import { Account, AccountIntent } from '../../types';
import { useHistory } from 'react-router';
import { formatAbn } from 'src/lib/formatter';

const useStyles = makeStyles((theme) => ({
  selectAccountContainer: {
    width: '100%',
    padding: theme.spacing(0, 2.5),
  },
  accountName: {
    fontWeight: 700,
  },
  selectAccountForm: {
    width: '100%',
  },
  selectMenu: {
    width: '23%',
  },
  abnLabel: {
    fontWeight: 500,
  },
}));

type LinkAccountSelectProps = {
  accounts: Account[];
  selectedAccount?: Account | undefined;
  accountIntent: AccountIntent;
  getAccountsToLink: (intentId: string) => Promise<any>;
  onChange: (account: Account) => void;
};

export const sortAccounts = (accounts: Account[]) => {
  return accounts.sort((a: Account, b: Account) => {
    if (a.name < b.name) {
      return -1;
    } else if (a.name > b.name) {
      return 1;
    }
    return 0;
  });
};

const LinkAccountSelect = (props: LinkAccountSelectProps) => {
  const { accountIntent, accounts, selectedAccount, getAccountsToLink, onChange } = props;
  const classes = useStyles();
  const history = useHistory();
  const [buyerAccounts, setBuyerAccounts] = useState<Array<Account>>(accounts);

  useEffect(() => {
    if (accountIntent && (!buyerAccounts || buyerAccounts.length === 0)) {
      getAccountsToLink(accountIntent.id).then((response: any) => {
        const { payload, error } = response;
        if (!error && payload.data.accounts) {
          setBuyerAccounts(payload.data.accounts);
          if (payload.data.accounts.length > 1) {
            const sortedAccounts: Account[] = sortAccounts(payload.data.accounts);
            setBuyerAccounts(sortedAccounts);
          }
        } else {
          history.push({
            pathname: '/500',
            state: { message: 'Account setup error. Call us on 1300 249 649' },
          });
        }
      });
    }
  }, [accountIntent, buyerAccounts]);

  const handleAccountChange = (event: any) => {
    const gcAccountId = event.target.value;

    const selectedBuyerAccount = buyerAccounts.find((x) => x.gcAccountId == gcAccountId);
    if (selectedBuyerAccount) {
      onChange(selectedBuyerAccount);
    }
  };

  return (
    <Grid container className={classes.selectAccountContainer}>
      <Grid item xs={12}>
        <FormControl className={classes.selectAccountForm} variant='outlined'>
          <Select
            name='accounts'
            id='accounts'
            data-testid='uia-accounts'
            onChange={handleAccountChange}
            value={selectedAccount && selectedAccount.gcAccountId}
            placeholder='SELECT A ACCOUNT'
            MenuProps={{ PaperProps: { className: classes.selectMenu } }}
          >
            {buyerAccounts &&
              buyerAccounts.map((account: Account) => (
                <MenuItem key={account.gcAccountId} data-testid='uia-accountItem' value={account.gcAccountId}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant='subtitle2' className={classes.accountName} component='label'>
                        {account.name}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant='body2' component='label' className={classes.abnLabel}>
                        ABN: &nbsp;
                      </Typography>
                      <Typography variant='body1' component='label'>
                        {formatAbn(account.abn)}
                      </Typography>
                    </Grid>
                  </Grid>
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default LinkAccountSelect;
